/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upgrade_Plan_Modal_Plans_Initial_DescriptionInputs */

const es_components_upgrade_plan_modal_plans_initial_description = /** @type {(inputs: Components_Upgrade_Plan_Modal_Plans_Initial_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un plan inicial económico para uso recurrente liviano.`)
};

const en_components_upgrade_plan_modal_plans_initial_description = /** @type {(inputs: Components_Upgrade_Plan_Modal_Plans_Initial_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An affordable starter plan for light ongoing use.`)
};

/**
* | output |
* | --- |
* | "An affordable starter plan for light ongoing use." |
*
* @param {Components_Upgrade_Plan_Modal_Plans_Initial_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_plans_initial_description = /** @type {((inputs?: Components_Upgrade_Plan_Modal_Plans_Initial_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_Plans_Initial_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_plans_initial_description(inputs)
	return en_components_upgrade_plan_modal_plans_initial_description(inputs)
});
export { components_upgrade_plan_modal_plans_initial_description as "components.upgrade_plan_modal.plans.initial.description" }